import closeupService from '@/api/closeup.service'

const actions = {
  adminCloseupUpdate: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .adminCloseupUpdate(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  adminCloseupUpload: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .adminCloseupUpload(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  adminCloseupUploadSinglePage: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .adminCloseupUploadSinglePage(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  adminCloseupDeleteSinglePage: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .adminCloseupDeleteSinglePage(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  adminCloseupDelete: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .adminCloseupDelete(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  candidateCloseupUploadPages: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .candidateCloseupUploadPages(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  upgradeCloseup: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .upgradeCloseup(context, data)
        .then(res => resolve(res))
        .catch(e => reject(e))
    })
    return response
  },
  updateCandidateCloseupCount: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .updateCandidateCloseupCount(context, data)
        .then(res => resolve(res))
        .catch(e => reject(e))
    })
    return response
  },
  updateCloseupWatchTime: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .updateCloseupWatchTime(context, data)
        .then(res => resolve(res))
        .catch(e => reject(e))
    })
    return response
  },
  getCloseupWatchTime: (context, email) => {
    console.log('email: ', email)
    let response = new Promise((resolve, reject) => {
      closeupService
        .getCloseupWatchTime(context, email)
        .then(res => {
          context.commit('updateWatchTime', res)
          resolve(res)
        })
        .catch(e => reject(e))
    })
    return response
  },
  candidateCloseupUpload: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .candidateCloseupUpload(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  evaluatePrecire: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .evaluatePrecire(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  candidateCloseupDelete: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .candidateCloseupDelete(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  createPayPalPaymentResource: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .createPayPalPaymentResource(context, data)
        .then(response => {
          context.commit('paypalResource', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  updatePayPalPayment: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .updatePayPalPayment(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  executePayPalPayment: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .executePayPalPayment(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  // getPayPalPaymentResource: (context, data) => {
  //   let response = new Promise((resolve, reject) => {
  //     closeupService.getPayPalPaymentResource(context, data)
  //       .then(response => {
  //         context.commit('paypalResource', response)
  //         resolve(response)
  //       }).catch(e => {
  //         reject(e)
  //       })
  //   })
  //   return response
  // },
  verifyVoucher: (context, data) => {
    let response = new Promise((resolve, reject) => {
      closeupService
        .verifyVoucher(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return response
  },
  saveCartProducts: (context, data) => {
    let response = new Promise((resolve, reject) => {
      context.commit('cart', data)
      resolve(data)
    })
    return response
  },
  saveBillingInfo: (context, data) => {
    let response = new Promise((resolve, reject) => {
      context.commit('billing', data)
      resolve(data)
    })
    return response
  },
}

export default actions
